exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".md-subhead[data-v-79c3781d]{opacity:1!important}.fullWidth[data-v-79c3781d]{width:100%}.flex[data-v-79c3781d]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:100%;padding-bottom:0}.type[data-v-79c3781d]{position:absolute;top:8px;right:8px;font-size:10px}.date[data-v-79c3781d]{position:absolute;bottom:8px;right:8px;font-size:10px}.autoComplete[data-v-79c3781d]{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79c3781d","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/peers/RecommendationPendingCard.vue
// module id = 959
// module chunks = 0